import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M35.333 12.6665H49.9997C52.9441 12.6665 55.333 15.0554 55.333 17.9998V47.3332C55.333 50.2776 52.9441 52.6665 49.9997 52.6665H35.333"
          stroke="#53B643"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M35.3332 53.9445C35.3332 55.632 33.7915 56.8889 32.1457 56.5625L11.8818 52.507C10.0137 52.1389 8.6665 50.4931 8.6665 48.5903V15.4098C8.6665 13.507 10.0137 11.8612 11.8818 11.4862L32.1457 7.43754C33.7915 7.11115 35.3332 8.3681 35.3332 10.0556V53.9445Z"
          stroke="#53B643"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M42 22H47.3333"
          stroke="#53B643"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42 32.6665H47.3333"
          stroke="#53B643"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42 43.3335H47.3333"
          stroke="#53B643"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.6108 41.5419C25.9511 41.5419 25.3052 41.2155 24.9233 40.6183L15.5899 25.9517C14.9997 25.0211 15.2705 23.785 16.2011 23.1878C17.1316 22.5975 18.3747 22.8683 18.9649 23.8058L28.2983 38.4725C28.8886 39.403 28.6177 40.6392 27.6872 41.2294C27.3538 41.4447 26.9788 41.5419 26.6108 41.5419Z"
          fill="#53B643"
        />
        <path
          d="M17.2774 41.5419C16.9094 41.5419 16.5344 41.4447 16.2011 41.2294C15.2705 40.6392 14.9997 39.403 15.5899 38.4725L24.9233 23.8058C25.5205 22.8683 26.7566 22.5975 27.6872 23.1878C28.6177 23.785 28.8886 25.0211 28.2983 25.9517L18.9649 40.6183C18.583 41.2155 17.9372 41.5419 17.2774 41.5419Z"
          fill="#53B643"
        />
      </svg>
    </>
  );
};
